import { client } from '@/proxy/client'
import { gql } from 'graphql-request'
import { useQuery } from '@/proxy/react-query'

export const SELLER_DOCUMENTS = gql`
  query sellerDocuments($input: DocumentInput!) {
    documents(input: $input) {
      id
      name
      structure
      description
    }
  }
`

export const SELLER_DOCUMENTS_KEY = 'useSellerDocuments'

export const useSellerDocuments = (variables, options) =>
  useQuery({
    queryKey: [SELLER_DOCUMENTS_KEY, variables],
    queryFn: () => client.request(SELLER_DOCUMENTS, variables),
    ...options,
  })
